import { useRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/signin"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        if (data.onboarding?.completed) navigate("/community", { state: { user: data } });
        else navigate("/onboarding", { state: { user: data } });
      } catch {
        setError("We couldn't complete your sign-in. Please try again.");
        setTimeout(() => navigate("/signin"), 1800);
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cream gap-6">
      <Logo />
      <div className="h-10 w-10 rounded-full border-4 border-rose border-t-teal animate-spin" />
      <p className="text-mutedplum">{error || "Signing you in…"}</p>
    </div>
  );
}
